import { Role } from '../../types/role';
import { AppConfig } from '../../app.config';

const SOCURE_SDK_URL = 'https://sdk.dv.socure.io/latest/device-risk-sdk.js';
// Bound how long init waits on Socure so a blocked or slow-loading SDK never stalls the app.
const SOCURE_SETUP_TIMEOUT_MS = 8000;

interface SigmaDeviceManager {
  initialize: (options: { sdkKey: string }) => void;
  getSessionToken: () => Promise<string>;
}

declare global {
  // eslint-disable-next-line no-var
  var SigmaDeviceManager: SigmaDeviceManager | undefined;
}

const conditionallySetupSocureSession = (role: Role | undefined): Promise<string | null> => {
  // ONLY SETUP SOCURE SESSION FOR CUSTOMERS
  if (role !== Role.Customer) {
    console.log('Socure session not setup for non customer roles');
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    let settled = false;
    const finish = (sessionToken: string | null) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      resolve(sessionToken);
    };

    const timeout = setTimeout(() => finish(null), SOCURE_SETUP_TIMEOUT_MS);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = SOCURE_SDK_URL;

    script.onload = () => {
      try {
        const manager = globalThis.SigmaDeviceManager;
        if (!manager) {
          finish(null);
          return;
        }
        manager.initialize({ sdkKey: AppConfig.socurePublicKey });
        manager
          .getSessionToken()
          .then((sessionToken) => finish(typeof sessionToken === 'string' && sessionToken !== '' ? sessionToken : null))
          .catch(() => finish(null));
      } catch (e) {
        console.log('socure getSessionToken error', e);
        finish(null);
      }
    };

    script.onerror = () => finish(null);

    document.body.appendChild(script);
  });
};

export { conditionallySetupSocureSession };
